<template>
  <div class="periodic-selected-facilities">
    <v-icon size="22px" color="primary" class="mr-3">
      icon-owner
    </v-icon>
    <div class="d-flex align-center mr-auto">
      <p class="periodic-selected-facilities__count">{{ selectedCount }}</p>
      <p
        class="periodic-selected-facilities__label"
        v-if="groupsCount || citiesCount"
      >
        {{ itemsLabel }}
      </p>
      <p class="periodic-selected-facilities__label" v-else-if="allSelected">
        {{ $t("message.analytics.periodic.allSelected") }}
      </p>
    </div>

    <v-btn class="ml-3" icon color="primary" @click="change">
      <v-icon>
        icon-edit
      </v-icon>
    </v-btn>
    <SectionLoader :status="loading" :opacity="1" />
  </div>
</template>

<script>
import SectionLoader from "@/components/Loader/SectionLoader.vue";

import { pluralCount } from "@/helpers/helpers";

export default {
  name: "SelectedFacilitiesIndicator",
  components: { SectionLoader },
  props: {
    selectedCount: {
      type: Number,
      required: true
    },
    allSelected: {
      type: Boolean,
      required: true
    },
    groupsCount: {
      type: Number,
      default: 0
    },
    citiesCount: {
      type: Number,
      default: 0
    },
    loading: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    itemsLabel() {
      return `(${pluralCount(
        `message.pluralForms.${this.groupsCount ? "group" : "city"}`,
        this.groupsCount || this.citiesCount
      )})`;
    }
  },
  methods: {
    change() {
      this.$emit("change");
    }
  }
};
</script>

<style lang="scss" scoped>
.periodic-selected-facilities {
  position: relative;
  display: flex;
  align-items: center;
  padding: $spacing * 0.5 $spacing * 2;
  padding-right: $spacing * 0.5;
  border: 1px solid rgba($text, 0.08);
  border-radius: 30px;
  min-width: 240px;

  &__count {
    margin-bottom: 0;
    @include font-size(12px);
    color: $text;
  }

  &__label {
    margin-bottom: 0;
    font-weight: 500;
    @include font-size(11px);
    color: $text;
    opacity: 0.55;
    margin-left: $spacing * 5 / 8;
  }
}
</style>
